const DojoTransactionNotifications = Object.freeze({
    APPROVED: 'APPROVED',
    ATTEMPTING_CANCEL: 'ATTEMPTING_CANCEL',
    BAD_SWIPE: 'BAD_SWIPE',
    CANCELLING: 'CANCELLING',
    CARD_ERROR: 'CARD_ERROR',
    CARD_EXPIRED: 'CARD_EXPIRED',
    CARD_NOT_SUPPORTED: 'CARD_NOT_SUPPORTED',
    CONNECTING: 'CONNECTING',
    CONNECTION_MADE: 'CONNECTION_MADE',
    DECLINED: 'DECLINED',
    DECLINED_BY_CARD: 'DECLINED_BY_CARD',
    INSERT_CARD: 'INSERT_CARD',
    PIN_ENTRY: 'PIN_ENTRY',
    PLEASE_WAIT: 'PLEASE_WAIT',
    PRESENT_CARD: 'PRESENT_CARD',
    PRESENT_ONLY_ONE_CARD: 'RESENT_ONLY_ONE_CARD',
    PROCESSING_ERROR: 'PROCESSING_ERROR',
    REMOVE_CARD: 'REMOVE_CARD',
    RETRYING: 'RETRYING',
    REQUEST_SENT: 'REQUEST_SENT',
    RE_PRESENT_CARD: 'RE_PRESENT_CARD',
    SIGNATURE_VERIFICATION: 'SIGNATURE_VERIFICATION',
    SIGNATURE_VERIFICATION_PROCESS_COMPLETED: 'SIGNATURE_VERIFICATION_PROCESS_COMPLETED',
    SIGNATURE_VERIFICATION_PROCESS_COULD_NOT_BE_COMPLETED: 'SIGNATURE_VERIFICATION_PROCESS_COULD_NOT_BE_COMPLETED',
    SIGNATURE_VERIFICATION_IN_PROGRESS: 'SIGNATURE_VERIFICATION_IN_PROGRESS',
    SIGNATURE_VERIFICATION_TIMEOUT: 'SIGNATURE_VERIFICATION_TIMEOUT',
    TRANSACTION_FINISHED: 'TRANSACTION_FINISHED',
    TRANSACTION_STARTED: 'TRANSACTION_STARTED',
    UNABLE_TO_CANCEL: 'UNABLE_TO_CANCEL',
});

module.exports = DojoTransactionNotifications;
